const getters = {
    metrics: (state) => state.metrics,
    id: (state) => state.id,
    loading: state => state.loading
};

export default getters;